import { render } from "./LeadMgmt.vue?vue&type=template&id=442fdec8&scoped=true"
import script from "./LeadMgmt.vue?vue&type=script&lang=js"
export * from "./LeadMgmt.vue?vue&type=script&lang=js"

import "./LeadMgmt.vue?vue&type=style&index=0&id=442fdec8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442fdec8"]])

export default __exports__